// extracted by mini-css-extract-plugin
export default {"textarea":"ProductReview_textarea__hNOSQ"};